import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Offer} from '../../../../../core/models/offer/offer.model';
import {isNestBank} from '../../../../../core/utils/utils';

@Component({
  selector: 'app-offers-comparison-panel',
  templateUrl: './offers-comparison-panel.component.html'
})
export class OffersComparisonPanelComponent implements OnInit {

  @Input() offers: Offer[];

  @Output() removeOffer: EventEmitter<Offer> = new EventEmitter<Offer>();
  @Output() clear: EventEmitter<void> = new EventEmitter<void>();
  @Output() compare: EventEmitter<void> = new EventEmitter<void>();

  clearComparisonButtonIcon: string;

  constructor() { }

  ngOnInit() {
    this.init();
  }

  removeOfferFromComparison(offer: Offer): void {
    this.removeOffer.emit(offer);
  }

  clearComparison(): void {
    this.clear.emit();
  }

  compareOffers(): void {
    this.compare.emit();
  }

  private init(): void {
    this.clearComparisonButtonIcon = isNestBank() ? './assets/images/icons/trash-bin-violet.svg' : './assets/images/icons/trash-bin.svg';
  }
}
